import {serverCall} from "@/redux/apis/http";
import {
    CREATE_LOCATION,
    LOCATION_FILTERS,
    UPDATE_LOCATION_PROPS,
    UPDATE_LOCATION_STATUS
} from "@/redux/rtk/admin/locations/types";

export const getAllLocations = async (data: LOCATION_FILTERS) => {
    return await serverCall({
        type: "get",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/getLocations",
        apiDir: `webapi/shared`,
    }, null)
}

export const getAllLocationsForSelect = async (pid: number) => {
    return await serverCall({
        type: "get",
        timeout: 1,
        data: {
            pid,
            customQueryFile: "locations"
        },
        endpoint: "/getAllLocationsForSelect",
        apiDir: `webapi/shared`,
    }, null)
}

export const getLocation = async (data: {uid: number}) => {
    return await serverCall({
        type: "get",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/getLocation",
        apiDir: `webapi/shared`,
    }, null)
}

export const createNewLocation = async (data: CREATE_LOCATION) => {
    return await serverCall({
        type: "post",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/createLocation",
        apiDir: `webapi/shared`,
    }, null)
}

export const updateLocation = async (data: UPDATE_LOCATION_PROPS) => {
    return await serverCall({
        type: "put",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/updateLocation",
        apiDir: `webapi/shared`,
    }, null)
}

export const deleteLocation = async (data: {uid: number}) => {
    return await serverCall({
        type: "delete",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/deleteLocation",
        apiDir: `webapi/shared`,
    }, null)
}

export const updateLocationStatus = async (data: UPDATE_LOCATION_STATUS) => {
    return await serverCall({
        type: "put",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/updateLocationStatus",
        apiDir: `webapi/shared`,
    }, null)
}